import { render, staticRenderFns } from "./nav-client.vue?vue&type=template&id=b976b3b0&scoped=true&"
import script from "./nav-client.vue?vue&type=script&lang=js&"
export * from "./nav-client.vue?vue&type=script&lang=js&"
import style0 from "./nav-client.vue?vue&type=style&index=0&id=b976b3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b976b3b0",
  null
  
)

export default component.exports